// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Field__Component__Label__Date > div[data-v-6816772a] {\n  width: 100%;\n  margin: 15px 5px;\n}\n.Field__Component__Label__Date > div[data-v-6816772a]:first-of-type {\n    margin-right: 0;\n}\n.Field__Component__Label__Date > div[data-v-6816772a]:last-of-type {\n    margin-left: 0;\n}\n", ""]);
// Exports
module.exports = exports;
